import axios from "axios";
import NProgress from "nprogress";
import Vue from "vue";
const client = axios.create({
  baseURL: Vue.prototype.$apiUrl,
  withCredentials: false
});

client.interceptors.request.use(config => {
  NProgress.start();
  return config;
});

client.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    return Promise.reject(error.response);
  }
);

// Class
function Update(cls) {
  return client.put("classes.php", cls);
}

function Create(cls) {
  cls.action = "create";
  return client.post("classes.php", cls);
}

function GetClass(id) {
  const params = {
    id: id,
    action: "class"
  };
  return client.get("classes.php", { params });
}

function GetClasses(status) {
  const params = {
    status: status,
    action: "classes"
  };
  return client.get("classes.php", { params });
}

function GetClassesByStudent(status, id) {
  const params = {
    id: id,
    status: status,
    action: "clsbystudent"
  };
  return client.get("classes.php", { params });
}

function Delete(id) {
  const params = {
    id: id
  };
  return client.delete("classes.php", { params });
}
// End Class

// Students
function UpdateStudent(student) {
  return client.put("students.php", student);
}

function CreateStudent(student) {
  student.action = "create";
  return client.post("students.php", student);
}

function GetStudent(id) {
  const params = {
    id: id,
    action: "student"
  };
  return client.get("students.php", { params });
}

function GetStudents(id) {
  const params = {
    id: id,
    action: "students"
  };
  return client.get("students.php", { params });
}

function DeleteStudent(id) {
  const params = {
    id: id
  };
  return client.delete("students.php", { params });
}
// End students

// Lessons
function GetLessons(id) {
  const params = {
    id: id,
    action: "lessons"
  };
  return client.get("classlessons.php", { params });
}

function GetLesson(id) {
  const params = {
    id: id,
    action: "lesson"
  };
  return client.get("classlessons.php", { params });
}

function UpdateLesson(lesson) {
  lesson.action = "update";
  return client.put("classlessons.php", lesson);
}

function StartFinishLesson(id, tp) {
  let lesson = {};
  lesson.action = tp === 1 ? "start" : "end";
  lesson.id = id;
  return client.put("classlessons.php", lesson);
}

function PublishLesson(id) {
  let lesson = {};
  lesson.action = "publish";
  lesson.id = id;
  return client.put("classlessons.php", lesson);
}

function GetStudentInLesson(id) {
  const params = {
    id: id,
    action: "students"
  };
  return client.get("classlessons.php", { params });
}

function StudentInLessonAction(lesson) {
  lesson.action = "markpresent";
  return client.put("classlessons.php", lesson);
}

function GetTaskInClass(id) {
  const params = {
    id: id,
    action: "inclass"
  };
  return client.get("classlessons.php", { params });
}

// End Lessons

function GetSchedule(filter) {
  const params = {
    id: filter.id,
    dtfrom: filter.start,
    dtto: filter.end,
    searchtype: filter.searchtype,
    action: "sched"
  };
  return client.get("classlessons.php", { params });
}

function GetScheduleByStudent(filter) {
  const params = {
    id: filter.id,
    dtfrom: filter.start,
    dtto: filter.end,
    searchtype: filter.searchtype,
    studentid: filter.studentid,
    action: "schedbystudent"
  };
  return client.get("classlessons.php", { params });
}

function GetMeetingLink(id) {
  const params = {
    id: id,
    action: "link"
  };
  return client.get("classlessons.php", { params });
}

export {
  GetClass,
  GetClasses,
  GetClassesByStudent,
  Delete,
  Create,
  Update,
  GetStudent,
  GetStudents,
  CreateStudent,
  UpdateStudent,
  DeleteStudent,
  GetLessons,
  UpdateLesson,
  StartFinishLesson,
  PublishLesson,
  GetLesson,
  GetStudentInLesson,
  StudentInLessonAction,
  GetTaskInClass,
  GetSchedule,
  GetScheduleByStudent,
  GetMeetingLink
};
